import type { I18nLanguage } from '@/i18n/const';

export const CREDIT_NOTICE_EVENT_STATUSES = ['in_progress', 'completed', 'failed'] as const;

export type CreditNoticeEventStatus = typeof CREDIT_NOTICE_EVENT_STATUSES[number];
export type CreditNoticeStatus = 'idle' | CreditNoticeEventStatus;

export interface CreditNoticeNextStep {
  step: number;
  title: string;
  description: string;
}

export interface CreditNoticeEvent {
  projectId: string;
  sessionId: string;
  noticeId: string;
  messageId: string;
  status: CreditNoticeEventStatus;
  summary?: string;
  goal?: string;
  suggestion?: string;
  nextSteps?: CreditNoticeNextStep[];
  panelLanguage?: I18nLanguage;
  receivedAt: number;
}

export interface CreditNoticeState {
  status: CreditNoticeStatus;
  event: CreditNoticeEvent | null;
  hasPriority: boolean;
  ignoredMessageId: string | null;
  summaryReveal: { projectId: string; noticeId: string } | null;
}

export interface CreditNoticeContext {
  currentProjectId: string;
  isFreeUser: boolean;
}
